export default __webpack_public_path__ + "media/avatars/06-475b15c1.png";